import PricingBreakdown from "./PricingBreakdown";
import { IoIosCheckbox } from "react-icons/io";

function PricingSectionToBeReimbursed({ data }) {
  return (
    <div className="w-full border h-fit border-gray-200 rounded-xl overflow-hidden bg-white mt-4 p-4">
      {/* Header */}
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-bold text-gray-900">Void</h2>
      </div>
      <div className="w-full mb-4 gap-2 flex flex-col">
        <div className="flex items-center gap-2">
          <span>
            <IoIosCheckbox className="text-2xl text-green-500" />
          </span>
          <span className="font-semibold text-sm">Voided, to re-imbursed</span>
        </div>
        <div className="text-xs">
          We will credit your Intraverse wallet once we receive the void from
          airline.
        </div>
      </div>

      {/* Content */}
      <div className="bg-primary1/5 p-4 text-sm text-gray-700">
        {/* Per-passenger sections */}
        <PricingBreakdown data={data} />
      </div>
    </div>
  );
}

export default PricingSectionToBeReimbursed;
